import { render, staticRenderFns } from "./EditOrderModal.vue?vue&type=template&id=dc4e18fa&scoped=true&"
import script from "./EditOrderModal.vue?vue&type=script&lang=js&"
export * from "./EditOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderModal.vue?vue&type=style&index=0&id=dc4e18fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4e18fa",
  null
  
)

export default component.exports